import { getLinks } from "@cinch-nx/data-storyblok";
import { policiesStaticPaths } from "./data/policies-static-paths";
export function getStaticPathsGenerator(slug) {
    return async ()=>{
        try {
            const links = await getLinks(slug);
            const filteredLinks = Object.fromEntries(Object.entries(links).filter(([, link])=>!link.slug.includes(slug)));
            const paths = policiesStaticPaths({
                links: filteredLinks
            });
            return {
                paths,
                fallback: "blocking"
            };
        } catch  {
            return {
                paths: [],
                fallback: "blocking"
            };
        }
    };
}
